import React from 'react';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import Icon from '@gcloud-npm/next12.components.icon-n';
import useMediaQuery from '@/hooks/useMediaQuery';
import FloatingPhoneNumber from '../FloatingPhoneNumber';
import styled from 'styled-components';

const StyledTextInfo = styled.div`
  @media screen and (max-width: 768px) {
    span {
      font-size: 1.125rem !important;
    }
  }
`;

const Header = (props) => {
  const { tipoEmpresa, link, call4selling } = props;

  const taggingInfo = {
    componentProduct: '',
    componentVariation: tipoEmpresa || 'all',
    componentName: 'Header',
  };

  const isDesktop = useMediaQuery('(min-width: 1224px)');
  return (
    <>
      <section className="Header">
        <div className="container">
          <div className="HeaderBar">
            <CustomLink
              taggingInfo={{
                ...taggingInfo,
                componentContent: 'HeaderBar',
              }}
              href={link}
            >
              <Icon {...props['Icon-1']} />
            </CustomLink>
            <div className="title">
              <StyledTextInfo>
                <TextInfo {...props['TextInfo-1']} segment="empresas" />
              </StyledTextInfo>
            </div>
            {isDesktop && call4selling && tipoEmpresa !== 'autonomo' && (
              <div className="floatingAlignRight">
                <FloatingPhoneNumber
                  taggingInfo={{
                    ...taggingInfo,
                    componentContent: 'FloatingPhoneNumber',
                  }}
                  Icon={Icon}
                  {...call4selling}
                />
              </div>
            )}
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .Header {
            background-color: var(--color-emp--blue);
            .HeaderBar {
              display: flex;
              align-items: center;
              height: 4.5rem;
              padding: 0 1rem 0 0.6875rem;
              .title {
                margin-left: 1.875rem;
              }
            }
          }

          @media screen and (min-width: 769px) {
            .Header {
              .HeaderBar {
                height: 5.625rem;
                .floatingAlignRight {
                  margin-left: auto;
                }
              }
            }
          }
        `}
      </style>
    </>
  );
};

export default Header;
